export default __webpack_public_path__ + "static/jcs-0fa4229bf7f13ddf65bac76919dc7f80.png";